/**
 * Таблица буква → код для тренажёра fano4.
 * Данные: { rows: [{letter, code}] }
 */
export default function TrainerCodeTable({
  table,
  compact = false,
  className = '',
}) {
  const rows = table?.rows || [];
  if (!rows.length) return null;

  return (
    <div className={`trainer-code-wrap ${compact ? 'is-compact' : ''} ${className}`.trim()}>
      <table className="trainer-code-table">
        <thead>
          <tr>
            <th>Буква</th>
            <th>Код</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.letter}>
              <td>{row.letter}</td>
              <td>
                <code>{row.code}</code>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
